import React from 'react';
import { Navigate } from 'react-router';
import Base from './Base';
import Document from "./Document";

export default class PersonCard extends Base {
    constructor(props) {
        super(props);
        this.state = {
            id: this.isNull(props.Id) ? this.defaultGuid() : props.Id,
            caller: props.Caller,
            data: null,
            loading: true,
            tab: 1
        }
    }
    componentDidMount() {
        this.httpPost("api/v1/person/card", {
            id: this.state.id,
        })
        .then(data => {
            if (data.status === -1) window.location.href = "/login";
            if (data.status === 1) {
                this.setState({
                    data: data,
                    loading: false
                })
            }
            else {
                this.showErorrMessage(data.message);
                this.setState({
                    loading: false
                });
            }
        });
    }
    showDocument(id) {
        this.showComponents({ component: <Document Caller={this} Id={id} /> });
    }
    renderForm() {
        return <div className="modal fade listModal in show" tabIndex="-1" role="dialog">
            <div className="modal-backdrop fade in" style={{ "height": "100%" }}></div>
            <div className="modal-dialog ui-draggable" style={{"width": "96%"}}>
                <div className="modal-content">
                    <div className="modal-body" style={{ "padding": "0" }}>
                        <div className="modal-header modal-header-info">
                            <button type="button" className="hand close" onClick={e => this.closeMe()} aria-label="Close"><span>×</span></button>
                            <h4 className="modal-title">اطلاعات شخص</h4>
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-sm-12">
                                    <ul className="nav nav-tabs">
                                        <li className={this.state.tab === 1 ? "active" : ""}><a onClick={e => this.setState({ tab: 1 })} className="hand">شناسنامه شخاص</a></li>
                                        <li className={this.state.tab === 2 ? "active" : ""}><a onClick={e => this.setState({ tab: 2 })} className="hand">صورتحساب</a></li>
                                        <li className={this.state.tab === 3 ? "active" : ""}><a onClick={e => this.setState({ tab: 3 })} className="hand">خرید و فروش کالا</a></li>
                                        <li className={this.state.tab === 4 ? "active" : ""}><a onClick={e => this.setState({ tab: 4 })} className="hand">خرید و فروش خدمات</a></li>
                                    </ul>
                                    <div className="tab-content">
                                        {this.state.tab === 1 && <div className="tab-pane fade active in">
                                            <div className="row">
                                                <div className="col-sm-12">
                                                    <div className="panel panel-info">
                                                        <div className="panel-body">
                                                            <div className="row">
                                                                <div className="col-sm-8">
                                                                    <h4 className="iransans txt-gray">
                                                                        {this.state.data.record.name}
                                                                        &nbsp;<small >({this.state.data.record.code})</small>
                                                                    </h4>
                                                                    <div className="acc-txt-10 text-gray">گروه: {this.state.data.record.groupName}</div>
                                                                </div>
                                                            </div>
                                                            <div className="row">
                                                                <div className="col-sm-6">
                                                                    <div className="bs-callout bs-callout-info row">
                                                                        <div className="row">
                                                                            <div className="col-xs-3">شماره تماس:</div>
                                                                            <div className="col-xs-9">{this.state.data.record.phone}</div>
                                                                        </div>
                                                                        <div className="row">
                                                                            <div className="col-xs-3">فکس:</div>
                                                                            <div className="col-xs-9">{this.state.data.record.fax}</div>
                                                                        </div>
                                                                        <div className="row">
                                                                            <div className="col-xs-3">ایمیل:</div>
                                                                            <div className="col-xs-9">{this.state.data.record.email}</div>
                                                                        </div>
                                                                        <div className="row">
                                                                            <div className="col-xs-3">وبسایت:</div>
                                                                            <div className="col-xs-9">{this.state.data.record.website}</div>
                                                                        </div>
                                                                        <div className="row">
                                                                            <div className="col-xs-3">استان:</div>
                                                                            <div className="col-xs-9">{this.state.data.record.ostan}</div>
                                                                        </div>
                                                                        <div className="row">
                                                                            <div className="col-xs-3">شهر:</div>
                                                                            <div className="col-xs-9">{this.state.data.record.city}</div>
                                                                        </div>
                                                                        <div className="row">
                                                                            <div className="col-xs-3">آدرس:</div>
                                                                            <div className="col-xs-9">{this.state.data.record.address}</div>
                                                                        </div>
                                                                        <div className="row">
                                                                            <div className="col-xs-3">موبایل:</div>
                                                                            <div className="col-xs-9">{this.state.data.record.mobile}</div>
                                                                        </div>
                                                                        <div className="row ng-hide">
                                                                            <div className="col-xs-3">ایمیل:</div>
                                                                            <div className="col-xs-9">{this.state.data.record.email}</div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="col-sm-6">
                                                                    <div className="bs-callout bs-callout-primary row">

                                                                        <div className={this.state.data.bed > this.state.data.bes ? "row txt-bold p-10 bg-danger" : "row txt-bold p-10"}>
                                                                            <div className="col-xs-6">مانده حساب:</div>
                                                                            <div className="col-xs-6 text-left">{this.state.data.record.remain} {this.state.data.global.company.currencyUnit} &nbsp;&nbsp; {this.state.data.record.remain != 0 ? "( " + this.state.data.record.tashkhis + " )" : null}</div>
                                                                        </div>
                                                                        <div className="row p-5">
                                                                            <div className="col-xs-2">بدهکار:</div>
                                                                            <div className="col-xs-4 text-danger txt-bold">{this.money(this.state.data.record.bed)} {this.state.data.global.company.currencyUnit}</div>
                                                                            <div className="col-xs-2">بستانکار:</div>
                                                                            <div className="col-xs-4 text-primary txt-bold">{this.money(this.state.data.record.bes)} {this.state.data.global.company.currencyUnit}</div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>}
                                        {this.state.tab === 2 && <div className="tab-pane fade active in">
                                            <div className="row">
                                                <div className="col-sm-12">
                                                    <button className="btn btn-no-frame btn-sm pull-left" title="اکسل">
                                                        <span className="fa fa-file-excel-o"></span>
                                                    </button>
                                                    <button className="btn btn-no-frame pull-left" title="چاپ">
                                                        <span className="fa fa-print"></span>
                                                    </button>
                                                    <button className="btn btn-no-frame pull-left" title="PDF">
                                                        <span className="fa fa-file-pdf-o"></span>
                                                    </button>
                                                </div>
                                            </div>

                                            {this.createTableHeader([
                                                { "w": '1 text-center', "f": "date", "c": "تاریخ" },
                                                { "w": '1 text-center', "f": "document_number", "c": "سند" },
                                                { "w": '3', "f": "description", "c": "شرح" },
                                                { "w": '2 text-center', "f": "bed", "c": "بدهکار" },
                                                { "w": '2 text-center', "f": "bes", "c": "بستانکار" },
                                                { "w": '2 text-center', "f": "remain", "c": "باقی مانده" },
                                                { "w": '1 text-center', "f": "tashkhis", "c": "تشخیص" },
                                            ], false)}
                                            {this.state.data.tab1.map(hit =>
                                                <div key={hit.id}>
                                                    <div className="row tb-row">
                                                        <div className="col-xs-1 text-center">{hit.date}</div>
                                                        <div className="col-xs-1 text-center">
                                                            <a className="text-primary txt-bold hand" onClick={e => this.showDocument(hit.id)}>{hit.number}</a>
                                                        </div>
                                                        <div className="col-xs-3">{hit.description}</div>
                                                        <div className="col-xs-2 text-center">{this.money(hit.bed)}</div>
                                                        <div className="col-xs-2 text-center">{this.money(hit.bes)}</div>
                                                        <div className="col-xs-2 text-center">{this.money(hit.remain)}</div>
                                                        <div className="col-xs-1 text-center">{hit.tashkhis}</div>
                                                    </div>
                                                </div>
                                            )}
                                        </div>}
                                        {this.state.tab === 3 && <div className="tab-pane fade in">
                                            <div className="row">
                                                <div className="col-sm-12">
                                                    <button className="btn btn-no-frame btn-sm pull-left" title="اکسل">
                                                        <span className="fa fa-file-excel-o"></span>
                                                    </button>
                                                    <button className="btn btn-no-frame pull-left" title="چاپ">
                                                        <span className="fa fa-print"></span>
                                                    </button>
                                                    <button className="btn btn-no-frame pull-left" title="PDF">
                                                        <span className="fa fa-file-pdf-o"></span>
                                                    </button>
                                                </div>
                                            </div>

                                            {this.createTableHeader([
                                                { "w": '1 text-center', "f": "code", "c": "کد" },
                                                { "w": '3', "f": "name", "c": "نام کالا" },
                                                { "w": '2 text-center', "f": "buy_count", "c": "تعداد خرید" },
                                                { "w": '2 text-center', "f": "sale_count", "c": "تعداد فروش" },
                                                { "w": '2 text-center', "f": "buy_price", "c": "قیمت خرید" },
                                                { "w": '2 text-center', "f": "sale_price", "c": "قیمت فروش" },
                                            ], false, "listHeader2")}
                                            {this.state.data.tab2.map(hit =>
                                                <div key={hit.id}>
                                                    <div className="row tb-row">
                                                        <div className="col-xs-1 text-center">{hit.code}</div>
                                                        <div className="col-xs-3">{hit.name}</div>
                                                        <div className="col-xs-2 text-center">{hit.buy_count}</div>
                                                        <div className="col-xs-2 text-center">{hit.sale_count}</div>
                                                        <div className="col-xs-2 text-center">{this.money(hit.buy_price)}</div>
                                                        <div className="col-xs-2 text-center">{this.money(hit.sale_price)}</div>
                                                    </div>
                                                </div>
                                            )}
                                        </div>}
                                        {this.state.tab === 4 && <div className="tab-pane fade active in">
                                            <div className="row">
                                                <div className="col-sm-12">
                                                    <button className="btn btn-no-frame btn-sm pull-left" title="اکسل">
                                                        <span className="fa fa-file-excel-o"></span>
                                                    </button>
                                                    <button className="btn btn-no-frame pull-left" title="چاپ">
                                                        <span className="fa fa-print"></span>
                                                    </button>
                                                    <button className="btn btn-no-frame pull-left" title="PDF">
                                                        <span className="fa fa-file-pdf-o"></span>
                                                    </button>
                                                </div>
                                            </div>
                                            {this.createTableHeader([
                                                { "w": '1 text-center', "f": "code", "c": "کد" },
                                                { "w": '2', "f": "name", "c": "نام خدمات" },
                                                { "w": '1 text-center', "f": "buy_count", "c": "تعداد خرید" },
                                                { "w": '1 text-center', "f": "sale_count", "c": "تعداد فروش" },
                                                { "w": '2 text-center', "f": "buy_price", "c": "قیمت خرید" },
                                                { "w": '2 text-center', "f": "sale_price", "c": "قیمت فروش" },
                                                { "w": '2 text-center', "f": "remain", "c": "گردش حساب" },
                                                { "w": '1 text-center', "f": "tashkhis", "c": "تشخیص" },
                                            ], false, "listHeader3")}
                                            {this.state.data.tab3.map(hit =>
                                                <div key={hit.id}>
                                                    <div className="row tb-row">
                                                        <div className="col-xs-1 text-center">{hit.code}</div>
                                                        <div className="col-xs-2">{hit.name}</div>
                                                        <div className="col-xs-1 text-center">{hit.buy_count}</div>
                                                        <div className="col-xs-1 text-center">{hit.sale_count}</div>
                                                        <div className="col-xs-2 text-center">{this.money(hit.buy_price)}</div>
                                                        <div className="col-xs-2 text-center">{this.money(hit.sale_price)}</div>
                                                        <div className="col-xs-2 text-center">{this.money(hit.remain)}</div>
                                                        <div className="col-xs-1 text-center">{hit.tashkhis}</div>
                                                    </div>
                                                </div>
                                            )}
                                        </div>}
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-default btn-smoke hand" onClick={e => this.closeMe()}>انصراف</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() : 
                    [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                        this.renderForm(),
                    ];

        return contents;
    }
}